import Icon from '../components/Icon.vue'

Icon.register({
  superscript: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M395.2 256C398.7 245.5 414 234.7 431.5 223.6 448.1 213 466.9 200.9 481.8 184.7 499.3 165.7 507.7 144.5 507.7 120.1 507.7 59.6 457 32 409.9 32 367.4 32 333.6 54 315.5 82.4 310.9 89.8 312.9 99.5 320.1 104.3L350.5 124.6C357.5 129.3 366.9 127.7 372.1 121 380.1 110.6 390.9 102.8 403.8 102.8 423.1 102.8 430 115.7 430 126.7 430 162.9 310.6 183.7 310.6 286.7 310.6 293.4 311.1 299.8 312 306.1 313.1 314 319.8 320 327.9 320H496C504.8 320 512 312.8 512 304V272C512 263.2 504.8 256 496 256H395.2zM272 416C280.8 416 288 423.2 288 432V464C288 472.8 280.8 480 272 480H209.6A16-16 0 0 0 196.1 472.5L150.4 399.9C148.1 396.6 145.9 392.9 144.2 389.7 142.5 392.9 140.5 396.6 138.3 400.3L93.6 472.4A16-16 0 0 0 80 480H16C7.2 480 0 472.8 0 464V432C0 423.2 7.2 416 16 416H42.3L98.9 333.3 46.1 256H16C7.2 256 0 248.8 0 240V208C0 199.2 7.2 192 16 192H84.8A16-16 0 0 0 98.5 199.6L138.3 264.8C140.4 268.3 142.4 271.9 144.1 275.1 145.8 271.9 148 268.2 150.3 264.6L190.6 199.6A16-16 0 0 0 204.2 192H272C280.8 192 288 199.2 288 208V240C288 248.8 280.8 256 272 256H244L191.3 331.7 250 416H272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/superscript.js
// module id = 5iGy
// module chunks = 144